import moment from 'moment'
import { IFilter } from '../store/ducks/report/types'
import { IAxiosResponse } from '../store/ducks/root.types'
import axiosInstance from './axios'

class ReportService {
  constructor(private apiVersion: string = 'v1') {
  }

  public async getAll(filter?: IFilter): Promise<IAxiosResponse<any>> {
    const params: URLSearchParams = this.buildParams(filter)
    return axiosInstance

      .get(`${this.apiVersion}/reports`, { params })
      .then((response) => {
        return {
          data: response.data,
          headers: response.headers
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar dados:", error)
        throw error
      })
  }

  public buildParams(filter?: IFilter): URLSearchParams {
    const params = new URLSearchParams()
    if (filter) {

      if (filter.primaryDate && filter.secondaryDate) {
        if (moment(filter.primaryDate).isAfter(filter.secondaryDate)) {
          params.append(`created_at`, `gte:${filter.secondaryDate}`)
          params.append(`created_at`, `lte:${filter.primaryDate}T23:59:59z`)
        }
        else {
          params.append(`created_at`, `gte:${filter.primaryDate}`)
          params.append(`created_at`, `lte:${filter.secondaryDate}T23:59:59z`)
        }
      }
      if (filter.state) {
        // filter.addressCity.map((county: string) => params.append(`address.city`, `${county}`))
        params.append(`address.state`, `${filter.state}`)
      }
      if (filter.addressCity) {
        // filter.addressCity.map((county: string) => params.append(`address.city`, `${county}`))
        params.append(`address.city`, `${filter.addressCity}`)
      }
    }
    return params
  }
}
const reportService = new ReportService()

export default reportService